import { FSBrand, mapFSBrand } from "../Brand";
import { FSColor, mapFSColor } from "../Color";
import { FSColorThemeType, mapFSColorThemeType } from "../ColorTheam/FSColorThemeType";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSItem, mapFSItem } from "../Item";
import { FSLocation, mapFSLocation } from "../Location";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSBathroomFeature, mapFSBathroomFeature } from "./BathroomFeature";
import { FSBathroomSubFeature, mapFSBathroomSubFeature } from "./BathroomSubFeature";

/* **************************************************** Finishing Shedule Bathroom */
export interface FSBathroom {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string;
    location_id: number | null;
    is_default_feature: 1 | 0;
    feature_list: FSBathroomFeatureData[];
    location: FSLocation | null;
    color_theme?:FSColorThemeType|null;
}

export const mapFSBathroom = (data: any): FSBathroom => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSBathroom = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        feature_list: Array.isArray(data.feature_list) ? mapFSBathroomFeatureDatas(data.feature_list) : [],
        location: data.location ? mapFSLocation(data.location) : null,
        color_theme: data.color_theme ? mapFSColorThemeType(data.color_theme) : null,
    };

    return res;
};

export const mapFSBathrooms = (data: any[]): FSBathroom[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSBathroom);
};

// Bathroom feature
export interface FSBathroomFeatureData {
    id: number;
    feature_name: string;
    status: 1 | 0;
    data_bathroom: FSBathroomData[];
}

export const mapFSBathroomFeatureData = (data: any): FSBathroomFeatureData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSBathroomFeatureData = {
        id: data.id,
        feature_name: data.feature_name,
        status: data.status,
        data_bathroom: Array.isArray(data.data_bathroom) ? mapFSBathroomDatas(data.data_bathroom) : []
    };

    return res;
};

export const mapFSBathroomFeatureDatas = (data: any[]): FSBathroomFeatureData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSBathroomFeatureData);
};
// 

// Bathroom data
export interface FSBathroomData {
    id: number;
    fs_data_id: number;
    bathroom_feature_id: number;
    sub_feature_id: number;
    brand_id: number | null;
    color_id: number | null;
    name: string | null;
    link: string | null;
    size: string | null;
    image_path: string | null;
    file_list: FSFileList[];
    is_not_updated: 1 | 0;
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite' | null;
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    feature: FSBathroomFeature | null;
    sub_feature: FSBathroomSubFeature | null;
    brand: FSBrand | null;
    color: FSColor | null;
}

export const mapFSBathroomData = (data: any): FSBathroomData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSBathroomData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        bathroom_feature_id: data.bathroom_feature_id,
        sub_feature_id: data.sub_feature_id,
        brand_id: data.brand_id || null,
        color_id: data.color_id || null,
        name: data.name || null,
        link: data.link || null,
        size: data.size || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        is_not_updated: data.is_not_updated,
        order_status: data.order_status || null,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        feature: data.feature ? mapFSBathroomFeature(data.feature) : null,
        sub_feature: data.sub_feature ? mapFSBathroomSubFeature(data.sub_feature) : null,
        brand: data.brand ? mapFSBrand(data.brand) : null,
        color: data.color ? mapFSColor(data.color) : null,
    };

    return res;
};

export const mapFSBathroomDatas = (data: any[]): FSBathroomData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSBathroomData);
};
// 